import { AdminContentListToolbarState } from "@/admin/content-library/filters/AdminContentListToolbar"
import DiscoTableFilterTags from "@disco-ui/table/header/filter/DiscoTableFilterTags"
import DiscoTag from "@disco-ui/tag/DiscoTag"
import { useTheme } from "@material-ui/core"

type Props = {
  filterState: AdminContentListToolbarState
  setFilterState: (state: AdminContentListToolbarState) => void
}

function AdminContentListFilterTags({ filterState, setFilterState }: Props) {
  const theme = useTheme()

  const showFilterTags =
    Boolean(filterState.contentLabels.length) ||
    Boolean(filterState.products.length) ||
    Boolean(filterState.collections.length) ||
    Boolean(filterState.contentUsageCount) ||
    typeof filterState.isAIGenerated?.value === "boolean"

  return (
    <DiscoTableFilterTags isVisible={showFilterTags} marginBottom={2}>
      {filterState.contentLabels.map((labelOption) => (
        <DiscoTag
          key={labelOption.value}
          testid={"AdminContentListFilterTag.content-label"}
          name={labelOption.title}
          backgroundColor={theme.palette.background.paper}
          onDelete={() => {
            const contentLabels = filterState.contentLabels.filter(
              (cl) => cl.value !== labelOption.value
            )
            const allContentLabels = contentLabels.length
              ? null
              : { value: "all", title: "All" }

            setFilterState({
              ...filterState,
              allContentLabels,
              contentLabels,
            })
          }}
        />
      ))}

      {filterState.products.map((productOption) => (
        <DiscoTag
          key={productOption.value}
          testid={"AdminContentListFilterTag.product"}
          name={productOption.title}
          backgroundColor={theme.palette.background.paper}
          onDelete={() => {
            const products = filterState.products.filter(
              (p) => p.value !== productOption.value
            )
            const allProducts = products.length ? null : { value: "all", title: "All" }

            setFilterState({
              ...filterState,
              allProducts,
              products,
            })
          }}
        />
      ))}

      {filterState.collections.map((collectionOption) => (
        <DiscoTag
          key={collectionOption.value}
          testid={"AdminContentListFilterTag.collection"}
          name={collectionOption.title}
          backgroundColor={theme.palette.background.paper}
          onDelete={() => {
            const collections = filterState.collections.filter(
              (p) => p.value !== collectionOption.value
            )
            const allCollections = collections.length
              ? null
              : { value: "all", title: "All" }

            setFilterState({
              ...filterState,
              allCollections,
              collections,
            })
          }}
        />
      ))}

      {filterState.contentUsageCount && (
        <DiscoTag
          testid={"AdminContentListFilterTag.contentUsageCount"}
          name={filterState.contentUsageCount.title}
          backgroundColor={theme.palette.background.paper}
          onDelete={() => {
            setFilterState({
              ...filterState,
              contentUsageCount: null,
            })
          }}
        />
      )}

      {typeof filterState.isAIGenerated?.value === "boolean" && (
        <DiscoTag
          testid={"AdminContentListFilterTag.created-by"}
          name={filterState.isAIGenerated.title}
          backgroundColor={theme.palette.background.paper}
          onDelete={() => {
            setFilterState({
              ...filterState,
              isAIGenerated: null,
            })
          }}
        />
      )}
    </DiscoTableFilterTags>
  )
}

export default AdminContentListFilterTags
